import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value"]

  update(value) {
    if (this.hasValueTarget) {
      this.valueTarget.textContent = value
    }
  }

}